import React from 'react'
import { Table } from 'rsuite'

export default function ApproverTable({ data, height = 350, style = { marginBottom: 20 } }) {
  const { Column, HeaderCell, Cell } = Table

  return (
    <Table
      // virtualized
      height={data?.values?.length > 5 ? height : 250}
      autoHeight={data?.values?.length <= 5}
      // autoHeight={true}
      data={data?.values || []}
      wordWrap
      style={style}
    >
      {data?.approveTypeText && (
        <Column width={200}>
          <HeaderCell>{data.approveTypeText}</HeaderCell>
          <Cell dataKey="approveType" />
        </Column>
      )}
      {data?.nameText && (
        <Column width={250}>
          <HeaderCell>{data.nameText}</HeaderCell>
          <Cell dataKey="name" />
        </Column>
      )}

      {data?.positionText && (
        <Column width={220} minWidth={220} flexGrow={1}>
          <HeaderCell>{data.positionText}</HeaderCell>
          <Cell dataKey="position" />
        </Column>
      )}
      {data?.approvedDateText && (
        <Column width={200}>
          <HeaderCell>{data.approvedDateText}</HeaderCell>
          <Cell dataKey="approvedDate" />
        </Column>
      )}
    </Table>
  )
}
